import { render, staticRenderFns } from "./Types.vue?vue&type=template&id=0c53f103&scoped=true"
import script from "./Types.vue?vue&type=script&lang=js"
export * from "./Types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c53f103",
  null
  
)

export default component.exports